import { tv } from '@otomoro/helpers/mergeClasses'
import { VariantProps } from 'tailwind-variants'

export const styles = tv({
	slots: {
		base: 'w-full flex flex-col md:grid md:grid-cols-6 gap-x-2 md:gap-x-4',
		imagesWrapper: 'flex flex-col-reverse gap-2 col-span-6 lg:grid lg:grid-cols-6 lg:gap-4 mt-3 lg:mt-4',
		primaryFigure: 'aspect-square lg:aspect-[887/550] rounded-l overflow-hidden col-span-4',
		secondaryFigure: 'aspect-[335/265] lg:aspect-[424/550] rounded-l col-span-2 overflow-hidden',
		image: 'w-full h-full object-cover',
		tagText: 'col-span-4 lg:col-span-6 mx-2 md:mx-4',
		header:
			'col-span-4 lg:col-span-6 grid grid-cols-4 lg:grid-cols-6 items-end mt-1 lg:mt-2 px-2 md:px-4',
		title: 'col-span-3 md:col-span-4 lg:max-w-[45rem]',
		desc: 'col-span-2 lg:col-span-2 mt-1 lg:mt-0',
	},
})

export type CardVariants = VariantProps<typeof styles>
